import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/see-your-thoughts.png';

export const SeeYourThoughtsStep = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>Developing Flexibility with Thoughts</S.StepHeading>
                <S.StepHeading>See Your Thoughts As Just That: Thoughts</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    <S.Strong>
                        Thoughts aren’t rules or laws, and we don’t have to follow them.{' '}
                    </S.Strong>
                    For example, imagine you have the thought “I can’t pick up this pen.” If you
                    listen to that thought, you might not even try pick up the pen. But if you
                    realize that it’s just a thought, you could have the thought “I can’t pick up
                    this pen” and you could pick up the pen anyway!
                </S.StepDescription>
                <S.StepDescription small>
                    You could also just practice saying "I'm having the thought that..." before any
                    thought you have e.g. "I'm having the thought that I can't pick up this pen.”
                    This helps create a little distance between you and the thought so you can
                    choose whether you want to listen to that thought or not.
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
);
